import { Card, Form } from 'antd';
import LoginForm from '../../components/monaliza/authentication/LoginForm';
import { useDispatch } from 'react-redux';
import { loginAsync } from '../../app/store/reducers/auth/authReducer';



const Login = () => {
  const dispatch = useDispatch()

  const onFinish = (values) => {
    console.log(values);
    dispatch(loginAsync({email: values?.email, password: values?.password}))
  };


  return (
    <>
            <Form
        name="normal_login"
        className="login-form"
        initialValues={{}}
        onFinish={onFinish}
        style={{
          width: "450px"
        }}
      >
        <Card className="my-5">
              <LoginForm/>
        </Card>
      </Form>
    </>
  )
}

export default Login